export const parseSiret = (value) => value.replace(/^[^0-9]*$/, '').substr(0, 14)
export const parsePhone = (value) => value.replace(/^[^0-9+]*$/, '').substr(0, 12)
export const parseZipCode = (value) => value.replace(/[^0-9]/, '').substr(0, 5)
